import { Environment } from "src/libs/environment";

export const BenefitsStorage = {
    Discounts: `${Environment.string(
        "BLOB_STORAGE_URL"
    )}/images/beneficios/descuentos`,
    Servings: `${Environment.string(
        "BLOB_STORAGE_URL"
    )}/images/beneficios/servicios`,
};

export const RewardsStorage = {
    Url: `${Environment.string(
        "BLOB_STORAGE_URL"
    )}/images/beneficios/recompensas`,
};
